__turbopack_context__.v({
  "addItemButton": "GgdY9G_addItemButton",
  "container": "GgdY9G_container",
  "headerContainer": "GgdY9G_headerContainer",
  "immutable": "GgdY9G_immutable",
  "mobileHeader": "GgdY9G_mobileHeader",
  "showNotes": "GgdY9G_showNotes",
});
